import React, { useState, useRef, useEffect } from "react";

import { Box, BoxCloseView, BoxOpenView, ControlsIcon } from "./style";
import { Spinner } from "../loading";

// /**
//  *  selectBox.
//  * @param {object} input
//  * input={
//  *    name: 'selectBox input name',
//  *    value: {object}'selectBox selected value'
//  *    value = {
//  *      'key':'selected KEY'
//  *      type: 'selected color style - a specification for each value',
//  *      value:'selected TEXT value',
//  *      icon:'selected ICON_NAME',
//  *      action:'selected action - when a specific value has specific onClick action',
//  *    }
//  *    onChange: {function},
//  *  }
//  * @param {string} size
//  * @param {boolean} hasIcon
//  * @param {boolean} hasBorder
//  * @param {array}  options
//  * options= [array of {object}input.value]
//  * @param {object} meta
//  * meta={
//  *   error:'error for selected value'
//  * }
//  * @param {string}   label
//  * @param {boolean}  disabled
//  */

export default props => {
  const [status, setStatus] = useState(false);

  const component = useRef(null);

  const {
    input,
    meta,
    label,
    hideText,
    disabled,
    hasBorder,
    icon,
    loading,
    options
  } = props;

  useOnClickOutside(component, () => setStatus(false));
  const selectItem = (e, value) => {
    e.stopPropagation();
    if (input.value && value.key !== input.value.key) {
      input.onChange(value);
    }
    setStatus(false);
  };

  const labelStatus = () => {
    if (input.value.value) {
      return "top";
    } else {
      return "down";
    }
  };

  const formStatus = () => {
    if (meta.error && typeof meta.error === "string") {
      return "error";
    }
    return status;
  };

  const labelRender = () => {
    return (
      <div className="label">
        <span>{label}</span>
      </div>
    );
  };
  const toggleOptions = () => {
    if (!disabled) {
      setStatus(!status);
    }
  };
  return (
    <Box
      ref={component}
      labelStatus={labelStatus()}
      status={status || formStatus()}
    >
      <BoxCloseView
        status={status}
        mode={input.value.mode}
        type={input.value.type}
        hasBorder={hasBorder}
        className={disabled ? "disabled" : ""}
        hideText={hideText}
        onClick={e => {
          e.stopPropagation();
          toggleOptions();
        }}
      >
        <span className="component-icon">
          <i className={`icon ${icon}`} />
        </span>
        {typeof input.value === "object" && (
          <div className="selected">
            <span>{input.value.value}</span>
          </div>
        )}

        {!loading ? (
          <ControlsIcon
            status={status}
            className={`icon ${
              props.openIcon ? props.openIcon : "mapsa-down-arrow"
            }`}
          />
        ) : (
          <span className="loading-container">
            <Spinner type="secondary" />
          </span>
        )}
      </BoxCloseView>
      {labelRender()}
      <BoxOpenView status={status}>
        <ul className="options">
          {options.map(option => {
            return (
              <li
                key={option.key}
                onClick={e => {
                  selectItem(e, option);
                }}
              >
                {option.value}
              </li>
            );
          })}
        </ul>
      </BoxOpenView>
      {meta.error && typeof meta.error === "string" && (
        <span className="notice">{meta.error}</span>
      )}
    </Box>
  );
};
function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = event => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        handler(event);
      };

      document.addEventListener("click", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("click", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}
